import { render, staticRenderFns } from "./card-branches.vue?vue&type=template&id=610eb68b&scoped=true&"
import script from "./card-branches.vue?vue&type=script&lang=js&"
export * from "./card-branches.vue?vue&type=script&lang=js&"
import style0 from "./card-branches.vue?vue&type=style&index=0&id=610eb68b&prod&lang=scss&scoped=true&"
import style1 from "./card-branches.vue?vue&type=style&index=1&id=610eb68b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610eb68b",
  null
  
)

export default component.exports